import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ loggedIn, children }) =>
	loggedIn ? children : <Navigate to="/" replace={true} />;
export default PrivateRoutes;
